export default __webpack_public_path__ + "static/media/banner_sr_user.3e9ab42f.png";